import * as React from "react";
import { useEffect } from "react";
import { routeConfig } from "../../../../config/language/ja-JP/presentation/route_text";
import { Project } from "../../../../domain/model/project";
import PageWrapper from "../../../common/atom/wrapper/page_wrapper";
import Breadcrumbs from "../../../common/molecular/breadcrumbs/breadcrumbs";
import Progress from "../../../common/organism/progress";
import { TBreadcrumbItem } from "../../../type/common";
import ClientProjectMainModifyForm from "./modify/client_project_main_modify_form";

interface IProps {
  isLoading: boolean;
  project: Project | null;
  handleUpdateProjectSubmit: (values: any) => void;
}

const ClientProjectModifyComponent: React.FC<IProps> = (props) => {
  const { isLoading, project, handleUpdateProjectSubmit } = props;

  const params = {
    initialValues: {
      project,
    },
    isLoading,
    onSubmit: handleUpdateProjectSubmit,
  };

  const breadcrumbItems: TBreadcrumbItem[] = [
    routeConfig.clientRoot,
    routeConfig.clientProjects,
    routeConfig.clientProjectEdit,
  ];

  useEffect(() => {
    window.addEventListener("beforeunload", onUnload);

    return () => {
      window.removeEventListener("beforeunload", onUnload);
    };
  });

  const onUnload = (e: any) => {
    e.preventDefault();
    e.returnValue = "";
  };

  return (
    <React.Fragment>
      {isLoading && <Progress canAnimation={false} />}
      <PageWrapper>
        <Breadcrumbs breadcrumbItems={breadcrumbItems} />

        <ClientProjectMainModifyForm {...params} enableReinitialize={true} />
      </PageWrapper>
    </React.Fragment>
  );
};

export default ClientProjectModifyComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/client/project/client_project_modify.tsx